import { getApiVersion, http } from '../utils/domain'
// 获取所有应用
export const fetchAllApps = (params) => {
  return http()
    .get(`${getApiVersion()}/apps/all`, {
      searchParams: params,
    })
    .json()
}
// 设置取消星标
export const setStar = (id, star) => {
  return http().put(`${getApiVersion()}/apps/${id}/star?star=${star}`).json()
}
// 删除应用
export const destroyApp = (id) => {
  return http().delete(`${getApiVersion()}/apps/${id}`).json()
}
// 恢复应用
export const recoveryApp = (id) => {
  return http().put(`${getApiVersion()}/apps/${id}/recovery`).json()
}
// 更新应用
export const updateApp = (id, data) => {
  return http().put(`${getApiVersion()}/apps/${id}`, data).json()
}
// 创建应用
export const createApp = (data) => {
  return http()
    .post(`${getApiVersion()}/apps/createAppWithInitInfo`, data)
    .json()
}
